// Module
var code = "<div id=\"V-5EBE3E97-F76B-434A-9FB1-DFADD4A9918E\"> <div style=\"width:100%;height:100%\" class=\"V-5EBE3E97-F76B-434A-9FB1-DFADD4A9918E\"> </div> </div> ";
// Exports
export default code;